import AppConfirmationDialog from './component'
export default AppConfirmationDialog



// WEBPACK FOOTER //
// ./src/components/AppConfirmationDialog/index.js